<div class="ion-card">
  <div class="ion-card-header">
    <div class="ion-card-title">Helping hand</div>
    <div class="ion-float-right">
      <div class="ion-fab-button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.82 66.6"><path d="M82,29.07a4.3,4.3,0,1,0-6.08,6.08A12.5,12.5,0,0,1,58.22,52.83l-8-8L59.06,36a21.09,21.09,0,0,0,0-29.82h0A20.92,20.92,0,0,0,44.17,0h0A20.92,20.92,0,0,0,29.23,6.18c-.08.08-.14.17-.21.25A21.11,21.11,0,0,0,29.27,36l6.94,6.89,6-6.11-6.93-6.87a12.49,12.49,0,1,1,17.65,0l-22.9,22.9A12.5,12.5,0,0,1,12.41,35.15a4.3,4.3,0,1,0-6.08-6.08A21.09,21.09,0,1,0,36.16,58.9l8-8,8,8A21.09,21.09,0,0,0,82,29.07Z"/></svg>
      </div>
    </div>
  </div>
  <div class="ion-card-content ion-padding-top">
    <div class="ion-card-subtitle">Due: {{today | date: 'd MMM'}}</div>
    <p class="ion-padding">We are looking for some extra help for our good cause.</p>
    <a href="/volunteers"><button class="button-solid button-tertiary button-round">Apply</button></a>
  </div>
</div>